<sh-card label="{{ 'tube.label.plane' | translate: { plane: tube.plane } }}">
  <div class="layout">
    <!-- timeline and error -->
    <div class="tube-timeline">
      <div class="flex align-c gap-20 sub-title">
        <sh-icon
          size="m"
          id="sh_icon"
          icon="{{ (marker$ | async)?.icon }}"
          [attr.color]="(marker$ | async)?.stateIconColor || null"
        >
        </sh-icon>
        <div class="flex align-c flex-column">
          <sh-text size="title-1" id="sh_status">
            {{ (marker$ | async)?.status }}
          </sh-text>
          <sh-text size="body-1" id="sh_recommendation">
            {{ (marker$ | async)?.recommendation }}
          </sh-text>
        </div>
      </div>
      <app-tube-timeline
        *ngIf="markersAndTubesReady$ | async"
        [data]="tube"
        [markers]="markers.lastSuccessfulData$ | async"
      ></app-tube-timeline>
    </div>
    <!-- tube info / details -->
    <div class="tube-info">
      <sh-grid fit-content="true">
        <div class="sub-title bold" columns="12">
          {{ 'tube.tubeInformation' | translate }}
        </div>
        <div class="text-info" columns="4" col-m="3" col-s="6">
          <sh-input-text
            readonly
            id="sh_tubeName"
            label="{{ 'tube.label.tube' | translate }}"
            [attr.aria-label]="'tube.label.tube' | translate"
            value="{{ tube.name }}"
          >
          </sh-input-text>
        </div>
        <div class="text-info" columns="4" col-m="3" col-s="6">
          <sh-input-text
            readonly
            id="sh_tubeSerialNumber"
            label="{{ 'tube.label.tubeSerialNumber' | translate }}"
            [attr.aria-label]="'tube.label.tubeSerialNumber' | translate"
            value="{{ tube.serialNumber }}"
          >
          </sh-input-text>
        </div>
        <div class="text-info" columns="4" col-m="3" col-s="6">
          <sh-input-text
            readonly
            id="sh_tubeMaterialNumber"
            label="{{ 'tube.label.tubeMaterialNumber' | translate }}"
            [attr.aria-label]="'tube.label.tubeMaterialNumber' | translate"
            value="{{ tube.materialNumber }}"
          >
          </sh-input-text>
        </div>
        <div class="text-info" columns="4" col-m="3" col-s="6">
          <sh-input-text
            readonly
            id="sh_deliveryDay"
            label="{{ 'tube.label.deliveryDay' | translate }}"
            [attr.aria-label]="'tube.label.deliveryDay' | translate"
            value="{{ tube.deliveryDay | localizedDate }}"
          >
          </sh-input-text>
        </div>
        <div class="text-info" columns="4" col-m="3" col-s="6">
          <sh-input-text
            readonly
            id="sh_currentScanCounter"
            label="{{ 'tube.label.currentScanCounter' | translate }}"
            [attr.aria-label]="'tube.label.currentScanCounter' | translate"
            value="{{ tube.currentScanCounter }}"
          >
          </sh-input-text>
        </div>
        <div class="text-info" columns="4" col-m="3" col-s="6">
          <sh-text>
            {{ 'tube.label.replacementPart' | translate }}
          </sh-text>
          <a
            href="{{ tube.urlToSPC }}"
            target="_blank"
            class="replacement-part-link"
          >
            <sh-button
              label="SPC {{ tube.materialNumber }}"
              color="secondary"
              icon="{{ tube.spcIcon }}"
              icon-position="left"
            ></sh-button>
          </a>
        </div>
      </sh-grid>
    </div>
  </div>
</sh-card>
